import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox, FormControlLabel, FormHelperText, Typography } from '@material-ui/core';
import MaterialGrid from '@material-ui/core/Grid';
import { Field, change } from 'redux-form';

export const AUDIENCE_OPTIONS = [
  { value: 'filiado', label: 'Filiados' },
  { value: 'amigo', label: 'Amigos' },
  { value: 'dependente', label: 'Dependentes' },
];

const AUDIENCE_NOT_APPLICABLE_TYPES = [1, 2, 19, 44];

export const isAudienceFeatureApplicable = (formValues) => {
  const typeId = parseInt(formValues?.type_id, 10);
  if (Number.isNaN(typeId)) return true;
  return !AUDIENCE_NOT_APPLICABLE_TYPES.includes(typeId);
};

export const audienceCheckbox = (option, disabled) => {
  const Cmp = ({ input }) => (
    <FormControlLabel
      control={
        <Checkbox
          checked={!!input.value}
          onChange={(e) => input.onChange(e.target.checked)}
          color="primary"
          disabled={disabled}
        />
      }
      label={option.label}
    />
  );
  Cmp.displayName = `AudienceCheckbox(${option.value})`;
  Cmp.propTypes = { input: PropTypes.object };
  return Cmp;
};

export const isStationGuestFeatureEnabled = (auth) =>
  !!auth?.user?.establishments?.[0]?.stations?.[0]?.guest_feature_enabled;

export const initAudienceFields = ({ auth, formValues, changeField, form }) => {
  if (!isStationGuestFeatureEnabled(auth)) return;
  if (!isAudienceFeatureApplicable(formValues)) return;
  const fv = formValues || {};
  const initialTypes = Array.isArray(fv.target?.audience_types)
    ? fv.target.audience_types
    : ['filiado'];
  if (fv.audience_filiado === undefined) {
    changeField(form, 'audience_filiado', initialTypes.includes('filiado'));
  }
  if (fv.audience_amigo === undefined) {
    changeField(form, 'audience_amigo', initialTypes.includes('amigo'));
  }
  if (fv.audience_dependente === undefined) {
    changeField(form, 'audience_dependente', initialTypes.includes('dependente'));
  }
};

export const initAudienceFieldsWithDispatch = ({ auth, formValues, dispatch, form }) => {
  initAudienceFields({
    auth,
    formValues,
    form,
    changeField: (formName, field, value) => dispatch(change(formName, field, value)),
  });
};

export const buildAudienceTypes = (auth, values) => {
  if (!isStationGuestFeatureEnabled(auth)) return undefined;
  const types = [];
  if (values?.audience_filiado) types.push('filiado');
  if (values?.audience_amigo) types.push('amigo');
  if (values?.audience_dependente) types.push('dependente');
  return types;
};

export const hasAnyAudienceSelected = (values) =>
  !!(values?.audience_filiado || values?.audience_amigo || values?.audience_dependente);

export const AudienceSection = ({ auth, isDisabled, formValues, marginTop = 16 }) => {
  if (!isStationGuestFeatureEnabled(auth)) return null;
  if (!isAudienceFeatureApplicable(formValues)) return null;
  return (
    <MaterialGrid item xs={12} style={{ marginTop }}>
      <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
        Selecione os grupos da atividade
      </Typography>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
        {AUDIENCE_OPTIONS.map((opt) => (
          <Field
            key={opt.value}
            name={`audience_${opt.value}`}
            component={audienceCheckbox(opt, isDisabled)}
          />
        ))}
      </div>
      {!hasAnyAudienceSelected(formValues) ? (
        <FormHelperText style={{ color: '#FF5A52' }}>
          Selecione pelo menos um público.
        </FormHelperText>
      ) : null}
    </MaterialGrid>
  );
};

AudienceSection.propTypes = {
  auth: PropTypes.object,
  isDisabled: PropTypes.bool,
  formValues: PropTypes.object,
  marginTop: PropTypes.number,
};
